module.exports = __webpack_public_path__ + "static/media/hw_ma_31.d0dcc725.flv";